<!--  -->
<template>
  <div v-loading="loading">
    <div style="margin: 10px 0 24px 0;" class="search_box">
      <el-input v-model="query.keyword" placeholder="请输入小程序名称/appid/编号" style="width:230px;margin: 0 8px;" />
      <el-input v-model="query.title" placeholder="请输入小程序标题" style="width:218px;margin: 0 8px;" />
      <el-input v-model="query.remark" placeholder="请输入小程序备注" style="width:218px;margin: 0 8px;" />
      <el-select v-model="query.type" placeholder="请选择小程序类型" style="width:218px;margin: 0 8px;">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-select v-model="query.onlyMe" placeholder="请选择" style="margin-left:10px">
        <el-option
          v-for="item in accountarr"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button type="primary" style="margin-left:10px" icon="el-icon-search" @click="searchclick">搜索</el-button>
      <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
      <el-button type="success" icon="el-icon-plus" @click="add">新增</el-button>
    </div>
    <div class="chooser_allbox">
      <div v-for="item,index in tableData" :key="index" class="chooser_box">
        <div style="margin: 14px">
          <div style="display: flex;">
            <div style="display: flex;align-items: center;">
              <img v-if="!item.weappiconurl || item.weappiconurl == null || item.weappiconurl == ''" src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" style="width:40px;border-radius: 50%;">
              <img v-else :src="item.weappiconurl" alt="" srcset="" style="width:40px;border-radius: 50%;">
              <!-- <div class="titlew_box">{{ item.title }}</div> -->
            </div>
            <div style="font-size: 16px;margin-left: 12px;font-weight: 400;color: #1D2129;width: 220px">
              <div style="height: 16px">{{ item.des_1 }}</div>
              <div style="font-size: 13px;color: #4E5969;margin-top: 8px;overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{ item.title }}</div>
            </div>
          </div>
          <div style="font-size: 12px;text-align: right;position: absolute;top: 14px;right: 14px;color: #86909C">{{ item.updated_at_str }}</div>
          <div class="cahrw_box">
            <img :src="item.thumburl" alt="" srcset="" style="width: auto;height: 178px;">
          </div>
          <div style="color:#252525;margin: auto">
            <span style="font-size: 15px;display: flex;align-items: center;flex-wrap: wrap;margin-bottom: 10px;">
              <el-avatar :size="20" :src="item.sender_avatar" @error="errorHandler">
                <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png">
              </el-avatar><el-tag v-if="item.sender!=''" style="margin-left: 10px;"> {{ item.sender }}</el-tag>
              <div style="margin-left:10px;max-width: 90px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;font-size:14px;color: #1D2129">{{ item.remark }}</div>
              <el-button
                v-clipboard:success="onCopys"
                v-clipboard:error="onErrors"
                v-clipboard:copy="apiUrl+text+item.app_id+textone+base64_encode(item.pagepath)"
                size="mini"
                style="margin-left:auto;color: #165DFF;border: 0;font-size: 14px;"
              >复制h5</el-button>
            </span>
            <div style="margin-bottom: 10px;display: flex;justify-content: space-between">
              <el-tag style="margin-right:10px;font-size: 14px;color: #3491FA;border-radius: 2px">{{ item.type_text }}</el-tag>
              <el-button v-if="item.enable == 2&&item.type==1" icon="el-icon-warning-outline" size="mini" style="margin-left: auto;color: red;border: 0;font-size: 14px">未开启</el-button>
            </div>
            <div style="font-size: 14px;margin-top: 10px;" class="copy_box">
              <el-tag v-if="item.miniprogram_no!=''" type="success" style="color: #0FC6C2;border-radius: 2px;font-size: 14px">{{ item.miniprogram_no }}</el-tag>
              <div v-if="item.miniprogram_no!=''" class="copy_icon"><i
                v-clipboard:copy="item.miniprogram_no"
                v-clipboard:success="cowe"
                v-clipboard:error="onError"
                style="cursor: pointer;margin-left: 2px;"
                class="el-icon-document-copy"
              /></div>
            </div>
          </div>
        </div>
        <div style="border-radius: 6px;position: absolute;bottom: 0;width: 100%;border-top: 1px solid #e9e9e9">
          <div style="width: 100%;border-radius: 6px;display: flex;">
            <button style="color: #4E5969;width: 50%;height: 40px;cursor: pointer;background-color: #fff;border: 0;border-radius: 0 0 0 6px;font-size: 16px" @click="editr(item,2)">编辑</button>
            <div style="height: 40px;width: 1.5px;background-color:#e9e9e9 " />
            <button v-if="item.type == 1 || item.type == 3" style="cursor: pointer;color: #165DFF;width: 50%;height: 40px;background-color: #fff;border: 0;font-size: 16px;border-radius: 0 0 6px 0" @click="editr(item,1)">复用</button>
          </div>
        </div>
      </div>

    </div>

    <pagination-right
      :current-page="query.page"
      :page-sizes="[20]"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      :title="alltype == 1 ? '复用小程序' :'修改小程序'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      width="40%"
    >
      <wechatdedit ref="wechatdeditview" @updata="updata" @updatawechat="updatawechat" />
    </el-dialog>
    <el-dialog
      title="新增小程序"
      :visible.sync="dialogVisiblewechat"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      append-to-body
      width="40%"
    >
      <addwechat ref="addwechatview" @updatawechat="updatawechat" />
    </el-dialog>
  </div>
</template>

<script>
import { miniprogramList } from '@/api/officialaccount.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import wechatdedit from './wechatdedit.vue'
import addwechat from './addwechat.vue'
export default {
  components: { PaginationRight, wechatdedit, addwechat },
  data() {
    return {
      query: {
        page: 1,
        page_size: 20,
        keyword: null,
        title: null,
        type: null,
        onlyMe: 2,
        remark: null
      },
      accountarr: [{
        value: 1,
        label: '查看组内小程序'
      }, {
        value: 2,
        label: '我关联的小程序'
      }],
      options: [
        {
          value: 1,
          label: '企微消息小程序'
        }, {
          value: 2,
          label: '微信客服小程序'
        }, {
          value: 3,
          label: '微信官方小程序'
        }
      ],
      tableData: [],
      total: null,
      itemwechat: {},
      dialogVisible: false,
      loading: false,
      dialogVisiblewechat: false,
      alltype: null,
      apiUrl: process.env.VUE_APP_BACKUP_API_URL.replace('api', ''),
      text: 'externalAddress/',
      textone: '?path='
    }
  },
  created() {
    console.log(this.query)
    this.list()
  },
  mounted() {

  },
  methods: {
    send() {
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.keyword = null
      this.query.title = null
      this.query.type = null
      this.query.onlyMe = 2
      this.query.remark = null
      this.list()
    },
    async list() {
      this.loading = true
      console.log(this.query, 12312312312312)
      const data = await miniprogramList(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      console.log('data', this.tableData)
    },
    add() {
      this.dialogVisiblewechat = true
      this.$nextTick(() => {
        this.$refs.addwechatview.sendr()
      })
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    choose(item) {
      console.log(item)
      this.$emit('wechatcallback', item)
    },
    edit(item) {
      this.dialogVisible = true
      this.itemwechat = item
    },
    sumbit() {
      if (this.itemwechat.des_1 === '') {
        this.$message({
          type: 'error',
          message: `请输入描述`
        })
        return
      }
      if (this.itemwechat.title === '') {
        this.$message({
          type: 'error',
          message: `请输入标题`
        })
        return
      }
      if (this.itemwechat.pagepath === '') {
        this.$message({
          type: 'error',
          message: `请输入跳转地址`
        })
        return
      }
      this.$emit('wechatcallback', this.itemwechat)
    },
    editr(item, alltype) {
      this.alltype = alltype
      console.log(item)
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.wechatdeditview.send(item, alltype)
      })
    },
    updata() {
      this.dialogVisible = false
      this.$message.success('编辑成功')
      this.list()
    },
    updatawechat(alltype) {
      console.log(alltype, 'alltype')
      // eslint-disable-next-line eqeqeq
      if (alltype == 1) {
        this.dialogVisible = false
      } else {
        this.dialogVisiblewechat = false
      }

      this.list()
    },
    cowe() {
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    onError() {
      this.$message({
        message: '复制失败',
        type: 'error'
      })
    },
    errorHandler() {
      return true
    },
    base64_encode(str) {
      // 使用 btoa() 对字符串进行 Base64 编码
      return btoa(unescape(encodeURIComponent(str)))
    },
    onCopys() {
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    onErrors() {
      this.$message({
        message: '复制失败',
        type: 'error'
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.chooser_allbox{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-height: 900px;
  overflow-y: auto;
}
.chooser_box{
  width: 300px;
  height: 420px;
  border: 1px solid #e9e9e9;
  border-radius: 6px;
  box-sizing: border-box;
  /* margin: 0 auto; */
  margin-bottom: 20px;
  margin-right: 18px;
  position: relative;
}
.titlew_box{
  margin-left: 5px;
  width: 127px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cahrw_box{
  margin: 14px 0;
  height: 178px;
  text-align: center;
  overflow: hidden;
}
.copy_box{
  display: flex;
  align-items: center;
}
.copy_icon{
  margin-left: 5px;
}
</style>
